<template>
  <div class="PostPermissions">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span class="font-sz24">{{ $t('岗位权限.岗位权限') }}</span>
        <div class="head-text">
          <el-button type="primary" @click="EditProjectRoleName">{{ $t('岗位权限.重命名') }}</el-button>
          <el-button type="primary" @click="copy">{{ $t('岗位权限.复制') }}</el-button>
          <el-button type="primary" @click="JurisdictionBtn">{{ $t('岗位权限.权限') }}</el-button>
          <el-button type="primary" @click="editorPost">{{ $t('common.添加') }}</el-button>
          <el-button type="danger" @click="removeBtnTitle">{{ $t('岗位权限.移除岗位') }}</el-button>
        </div>
      </div>
      <el-container>
        <el-menu :default-active="gids" class="h650-ov-a" @select="handselect">
          <el-menu-item class="menu-left" v-for="item in menuData" :key="item.pror01" :index="item.pror01.toString()">
            <span style="text-align: center" class="title-left" slot="title" :title="item.pror02">{{ item.pror02
            }}</span>
          </el-menu-item>
        </el-menu>
        <div class="view">
          <div class="rygl-table">
            <el-table align="center" class="margin-20 table width100" v-loading="loading" :data="postList" height="72vh"
              @selection-change="handleSelectionChange" :loading="loading">
              <el-table-column align="center" type="selection" width="55"></el-table-column>
              <el-table-column align="center" prop="user02" :label="$t('岗位权限.账号')"></el-table-column>
              <el-table-column align="center" prop="user04" :label="$t('岗位权限.姓名')"></el-table-column>
              <el-table-column align="center" prop="prde03" :label="$t('岗位权限.组织机构')"></el-table-column>
              <el-table-column align="center" prop="pror02" :label="$t('岗位权限.岗位')"></el-table-column>
              <el-table-column align="center" prop="user12" :label="$t('岗位权限.邮箱')"></el-table-column>
              <el-table-column align="center" prop="user11" :label="$t('岗位权限.手机号')"></el-table-column>
              <el-table-column align="center" :label="$t('岗位权限.操作')">
                <template slot-scope="scope">
                  <el-button size="small" type="danger" plain @click="removeBtnUser(scope.row)">{{ $t('common.删除')
                  }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-container>
      <!-- 编辑岗位 -->
      <el-dialog :close-on-click-modal="false" :title="$t('岗位权限.添加岗位')" :visible.sync="editorPost1">
        <el-row>
          <el-col :span="3" :offset="5" class="mar-top10">{{ $t('岗位权限.岗位名称') }}：</el-col>
          <el-col :span="6">
            <el-input :placeholder="$t('岗位权限.请输入岗位名称')" v-model="postName.name"></el-input>
          </el-col>
        </el-row>
        <el-row class="mar-top40">
          <el-col :span="2" :offset="8">
            <el-button type="primary" @click="add">{{ $t('common.确定') }}</el-button>
          </el-col>
          <el-col :span="2" :offset="2">
            <el-button type="danger" @click="editorPost1 = false">{{ $t('common.取消') }}</el-button>
          </el-col>
        </el-row>
      </el-dialog>
    </el-card>
    <!-- 权限对话框 -->
    <el-dialog :close-on-click-modal="false" :title="$t('岗位权限.权限管理')" :visible.sync="centerDialogVisible" width="40%"
      top="5%" center><el-tree ref="tree" class="sss" style="height: 600px; overflow: auto" :data="Jurisdiction"
        show-checkbox default-expand-all node-key="id" :default-checked-keys="permissions"
        :props="defaultProps"></el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">{{ $t('common.取消') }}</el-button>
        <el-button type="primary" @click="submitPermissions">{{ $t('common.确定') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetObesity,
  RemoveObesity,
  UpdateObesity,
  GetProjectRole,
  RemoveObesityUser,
  AddObesity,
  RoleSetting,
  findRoleRight,
  updateRoleRight,
  EditProjectRoleName,
} from "@/setAxios.js";
// import { ProjectBureau as Jurisdiction } from "@/jurisdiction";
export default {
  name: "PostPermissions",
  data() {
    return {
      copyName: "",
      copyValue: null,
      permissions: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      Jurisdiction: [{
        id: 1,
        label: this.$t('岗位权限.项目管理'),
        children: [{
          id: 101,
          label: this.$t('岗位权限.团队成员'),
          children: [{
            id: 1011,
            label: this.$t('岗位权限.电话加密'),
          }, {
            id: 1012,
            label: this.$t('岗位权限.邮箱加密'),
          }, {
            id: 1013,
            label: this.$t('岗位权限.使用话题讨论'),
          },],
        },
        {
          id: 102,
          label: this.$t('岗位权限.协作沟通'),
          children: [{
            id: 1021,
            label: this.$t('岗位权限.使用工单任务'),
          },
          {
            id: 1022,
            label: this.$t('岗位权限.发起任务'),
          },
            // {
            //     id: 1023,
            //     label: "使用流程表单",
            // },
            // {
            //     id: 1024,
            //     label: "发起流程表单",
            // },
          ]
        },
        {
          id: 103,
          label: this.$t('岗位权限.进度管理'),
          children: [{
            id: 1031,
            label: this.$t('岗位权限.三维模拟'),
          },
          {
            id: 1032,
            label: this.$t('岗位权限.进度计划'),
            children: [{
              id: 10321,
              label: this.$t('岗位权限.新建'),
            },
            {
              id: 10322,
              label: this.$t('岗位权限.删除'),
            }
            ]
          }, {
            id: 1033,
            label: this.$t('岗位权限.进度展示'),
            children: [{
              id: 10332,
              label: this.$t('岗位权限.查看'),
            }, {
              id: 10331,
              label: this.$t('岗位权限.编辑'),
            }]
          }
          ]
        },
        {
          id: 104,
          label: this.$t('岗位权限.资料管理'),
          children: [{
            id: 1041,
            label: this.$t('岗位权限.新建'),
          },
          {
            id: 1042,
            label: this.$t('岗位权限.删除'),
          },
          {
            id: 1043,
            label: this.$t('岗位权限.分享'),
          },
          {
            id: 1044,
            label: this.$t('岗位权限.查看关联'),
          },
          {
            id: 1045,
            label: this.$t('岗位权限.下载'),
          }
          ]
        },
        {
          id: 105,
          label: this.$t('岗位权限.图纸管理'),
          children: [{
            id: 1541,
            label: this.$t('岗位权限.新建'),
          },
          {
            id: 1052,
            label: this.$t('岗位权限.删除'),
          },
          {
            id: 1053,
            label: this.$t('岗位权限.分享'),
          },
          {
            id: 1054,
            label: this.$t('岗位权限.下载'),
          },
          ]
        },
        {
          id: 106,
          label: this.$t('岗位权限.条码管理'),
          children: [{
            id: 1061,
            label: this.$t('岗位权限.生成'),
          }, {
            id: 1062,
            label: this.$t('岗位权限.打印'),
          }]
        },
        {
          id: 107,
          label: this.$t('岗位权限.实景管理'),
          children: [{
            id: 1071,
            label: this.$t('岗位权限.上传'),
          }]
        },
        ],
      },
      ],
      query: "",
      gids: null,
      // 这个是岗位名称
      postName: [],
      menuData: [],
      postList: [],
      pagesize: 10,
      pagenum: 1,
      total: 0,
      loading: false,
      editorPost1: false,
      centerDialogVisible: false,
      removeTileBtnId: null,
      gidS: null,
      model: null,
      schoolPost: {
        pror01: 0,
        pror02: "",
        pror04: parseInt(localStorage.getItem("xid")),
        pror03: "",
        pror05: new Date(),
        pror07: parseInt(localStorage.getItem("id")),
      },
    };
  },
  methods: {
    EditProjectRoleName() {
      this.$prompt(this.$t('岗位权限.请输入岗位名称'), this.$t('岗位权限.重命名'), {
        confirmButtonText: this.$t('common.确定'),
        cancelButtonText: this.$t('common.取消'),
      }).then(({ value }) => {
        let params = {
          id: this.removeTileBtnId,
          name: value,
        };
        EditProjectRoleName(params).then((res) => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: this.$t('common.处理成功'),
            });
            this.getData(this.removeTileBtnId);
          }
        });
      });
    },
    copy() {
      if (this.removeTileBtnId === null) {
        this.$message.error(this.$t('common.请先选择'));
      } else {
        let params = {
          pror01: this.removeTileBtnId,
        };
        findRoleRight(params).then((res) => {
          this.model = res.Data;
          if (res.Data.pror03 !== null) {
            this.permissions = res.Data.pror03.split(",");
          } else {
            this.permissions = [];
          }
        });
      }
      this.$prompt(this.$t('岗位权限.请输入岗位名称'), this.$t('岗位权限.复制'), {
        confirmButtonText: this.$t('common.确定'),
        cancelButtonText: this.$t('common.取消'),
      }).then(({ value }) => {
        this.schoolPost.pror02 = value;
        this.schoolPost.pror03 = this.permissions.join(",");
        let params = JSON.stringify(this.schoolPost);
        AddObesity({ addpror: params }).then((res) => {
          this.editorPost1 = false;
          this.getData();
        });
      });
    },
    // 确定岗位权限
    submitPermissions() {
      this.model.pror03 = this.$refs.tree.getCheckedKeys().join();
      this.permissions = this.$refs.tree.getCheckedKeys();
      updateRoleRight({ model: this.model }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: this.$t('common.处理成功')
          });
          this.centerDialogVisible = false;
        }
      });
    },
    // 侧边栏
    handselect(key, keyPath) {
      this.permissions = [];
      this.gidS = key;
      //(key, keyPath);
      this.loading = true;
      this.removeTileBtnId = key;
      let params = {
        id: localStorage.getItem("xid"),
        cid: localStorage.getItem("pid"),
        gid: key,
      };

      GetObesity({ params }).then((res) => {
        this.postList = res.Data;
        this.loading = false;
      });
    },
    // 删除用户信息
    removeBtnUser(row) {
      //(row);
      let uid = row.user01;
      let gid = row.pror01;
      let xid = localStorage.getItem("xid");
      RemoveObesityUser({ uid, gid, xid })
        .then((res) => {
          //(res, "aa");
          if (res.Code === 0) {
            this.$message.error(this.$t('common.至少保留一个'));
            this.getData(row.pror01);
          }
          this.getData(row.pror01);
          this.loading = false;
        })
        .catch((error) => {
          this.$message.error(this.$t('common.至少保留一个'));
          //(error); //错误处理 相当于error
        });
    },
    //删除岗位权限标题
    removeBtnTitle() {
      if (this.removeTileBtnId === null) {
        this.$message.error(this.$t('common.请先选择'));
      } else {
        this.$confirm(this.$t('common.删除询问'), this.$t('common.提示'), {
          confirmButtonText: this.$t('common.确定'),
          cancelButtonText: this.$t('common.取消'),
          type: "warning",
        })
          .then(() => {
            let xid = JSON.stringify(parseInt(localStorage.getItem("xid")));
            let gid = JSON.stringify(parseInt(this.removeTileBtnId));
            RemoveObesity({ xid, gid }).then((res) => {
              if (res.Code == 1) {
                this.$message({
                  type: "success",
                  message: this.$t('common.处理成功')
                });
                this.getData(this.removeTileBtnId);
                this.loading = false;
              } else if (res.Code == -2) {
                this.$message({
                  type: "warning",
                  message: this.$t('common.处理失败')
                });
                this.getData(this.removeTileBtnId);
                this.loading = false;
              } else if (res.Code == 0) {
                this.$message({
                  type: "warning",
                  message: this.$t('common.处理失败')
                });
                this.getData(this.removeTileBtnId);
                this.loading = false;
              }
            });
          })
      }
    },

    // 这里是添加岗位名称
    editorPost() {
      this.editorPost1 = true;
    },
    //这里是添加岗位确定按钮
    add() {
      this.schoolPost.pror02 = this.postName.name;
      let params = JSON.stringify(this.schoolPost);
      AddObesity({ addpror: params }).then((res) => {
        this.editorPost1 = false;
        this.getData();
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.pagesize = val;
    },
    handleCurrentChange(val) {
      this.pagenum = val;
    },
    // 获取所有数据
    getData(i) {
      this.loading = true;
      let ss = {
        xid: parseInt(localStorage.getItem("xid")),
      };
      GetProjectRole(ss).then((res) => {
        // console.log(res, "======>666");
        this.menuData = res.Data;
        if (!this.menuData.length) {
          this.loading = false;
          return false;
        }
        this.gids = res.Data[0].pror01.toString();
        this.removeTileBtnId = res.Data[0].pror01;
        this.menuData.map((i, index) => {
          i["icon"] = "el-icon-s-custom";
        });
        let params = {
          id: parseInt(localStorage.getItem("xid")),
          gid: i ? i : res.Data[0].pror01,
          cid: localStorage.getItem("pid"),
        };
        GetObesity({ params }).then((res) => {
          //(res, "岗位列表");
          this.postList = res.Data;
          this.loading = false;
        });
      });
    },
    // 这里是权限弹出框
    JurisdictionBtn() {
      if (this.removeTileBtnId === null) {
        this.$message.error(this.$t('common.请先选择'));
      } else {
        let params = {
          pror01: this.removeTileBtnId,
        };
        findRoleRight(params).then((res) => {
          this.model = res.Data;
          if (res.Data.pror03 !== null) {
            this.permissions = res.Data.pror03.split(",");
          } else {
            this.permissions = [];
          }
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(this.permissions);
            // this.$refs.tree2.setCheckedKeys(this.permissions);
          });
          this.centerDialogVisible = true;
        });
      }
    },
    handleCheckChange(data, checked, indeterminate) {
      // 共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点本身是否被选中、节点的子树中是否有被选中的节点
      // console.log(data, checked, indeterminate);
      if (checked && !this.permissions.includes(data.id)) {
        this.permissions.push(data.id);
      } else {
        this.permissions.forEach((ele, index) => {
          if (ele == data.id) {
            this.permissions.splice(index, 1);
          }
        });
      }
    },
    handleCheckChange2(data, checked, indeterminate) {
      // 共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点本身是否被选中、节点的子树中是否有被选中的节点
      // console.log(data, checked, indeterminate);
      if (checked && !this.permissions.includes(data.id)) {
        this.permissions.push(data.id);
      } else {
        this.permissions.forEach((ele, index) => {
          if (ele == data.id) {
            this.permissions.splice(index, 1);
          }
        });
      }
    },
  },
  created() {
    this.getData();
    // this.gids = localStorage.getItem("gid");
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.el-menu-item.is-active span {
  // background: #38c6ff;
  // color: #fff;
}

.el-menu-item,
.el-submenu__title {
  letter-spacing: 0px;
}

.el-menu-item.is-active {
  background: #38c6ff;
  color: #fff;
}

.el-menu span {
  width: 120px;
}

.view {
  width: 100%;
  height: 100%;
}

.search-input {
  width: 300px;
}

/deep/ .el-card__body {
  padding: 0;
}

.icons {
  position: absolute;
  margin-left: -60px;
  top: 4px;
  z-index: 999;
  display: block;
  width: 50px;
  height: 50px;
  background-color: red;
}

/deep/ .el-tree-node__content {
  padding: 20px 0;
}

/deep/ body .el-tree-node__children div {
  padding: 0;
}

/deep/ .sss {
  position: relative;

  &::before {
    content: "";
    position: absolute;
    // background-image: url("~@/assets/img/认证用户.png");
    background-size: cover;
    background-repeat: no-repeat;
    width: 30px;
    height: 30px;
    margin: 8px -60px;
  }
}

// /deep/ .sss .el-tree-node:nth-child(2) {
//   &::before {
//     content: "";
//     position: absolute;
//     width: 50px;
//     height: 50px;
//     margin: 8px -60px;
//     background-image: url("~@/assets/img/评论.png");
//     background-size: cover;
//     background-repeat: no-repeat;
//   }
// }
// /deep/ .sss .el-tree-node:nth-child(3) {
//   &::before {
//     content: "";
//     position: absolute;
//     width: 50px;
//     height: 50px;
//     margin: 8px -60px;
//     background-image: url("~@/assets/img/编辑.png");
//     background-size: cover;
//     background-repeat: no-repeat;
//   }
// }
// /deep/ .sss .el-tree-node:nth-child(4) {
//   &::before {
//     content: "";
//     position: absolute;
//     width: 50px;
//     height: 50px;
//     margin: 8px -60px;
//     background-image: url("~@/assets/img/安全.png");
//     background-size: cover;
//     background-repeat: no-repeat;
//   }
// }
// /deep/ .bbb {
//   &::before {
//     content: "";
//     position: absolute;
//     width: 50px;
//     height: 50px;
//     margin: 8px -60px;
//     background-image: url("~@/assets/img/换肤.png");
//     background-size: cover;
//     background-repeat: no-repeat;
//   }
// }
// /deep/ .bbb .el-tree-node:nth-child(2) {
//   &::before {
//     content: "";
//     position: absolute;
//     width: 50px;
//     height: 50px;
//     margin: 8px -60px;
//     background-image: url("~@/assets/img/进度管理.png");
//     background-size: cover;
//     background-repeat: no-repeat;
//   }
// }
// /deep/ .bbb .el-tree-node:nth-child(3) {
//   &::before {
//     content: "";
//     position: absolute;
//     width: 50px;
//     height: 50px;
//     margin: 8px -60px;
//     background-image: url("~@/assets/img/个人资料.png");
//     background-size: cover;
//     background-repeat: no-repeat;
//   }
// }
// /deep/ .bbb .el-tree-node:nth-child(4) {
//   &::before {
//     content: "";
//     position: absolute;
//     width: 50px;
//     height: 50px;
//     margin: 8px -60px;
//     background-image: url("~@/assets/img/标签.png");
//     background-size: cover;
//     background-repeat: no-repeat;
//   }
// }
/deep/ .el-tree-node__children div::before {
  display: none;
}
</style>
<style scoped>
/* 新增 */
.font-sz24 {
  font-size: 24px;
}

.head-text {
  float: right;
  margin-top: -4px;
}

.h650-ov-a {
  height: 650px;
  width: 165px;
  overflow-y: auto;
  overflow-x: hidden;
}

.width100 {
  width: 100%;
}

.mar-top10 {
  margin-top: 10px;
}

.mar-top40 {
  margin-top: 40px;
}

.pad-left90 {
  padding-left: 90px;
}

.pad-left40 {
  padding-left: 40px;
}
</style>
